import React from "react";
import { Download, FileText, Video } from "lucide-react";

export default function SalesKitPanel() {
  const base = process.env.REACT_APP_BACKEND_URL;
  const links = [
    {
      href: `${base}/api/downloads/Cricket_Graphics_Studio_Walkthrough.docx`,
      testid: "download-walkthrough-docx",
      icon: FileText,
      title: "Customer Walkthrough (.docx)",
      desc: "2-page product overview + pricing table — WhatsApp-ready",
      iconBg: "bg-blue-600/15 text-blue-300",
    },
    {
      href: `${base}/api/downloads/Cricket_Graphics_Studio_5min_Video_Script.docx`,
      testid: "download-video-script-docx",
      icon: Video,
      title: "5-min Video Script (.docx)",
      desc: "Scene-by-scene script to record via Loom / OBS in 15 min",
      iconBg: "bg-red-600/15 text-red-300",
    },
  ];
  return (
    <div className="glass rounded-xl border border-slate-800 p-5 mb-8">
      <div className="flex items-center justify-between flex-wrap gap-3 mb-4">
        <div>
          <div className="flex items-center gap-2 text-slate-300 font-semibold"><Download size={16} /> Sales Kit</div>
          <div className="text-slate-400 text-sm mt-1">Share these with prospects on WhatsApp / email</div>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {links.map(l => (
          <a key={l.testid} href={l.href} data-testid={l.testid}
            className="flex items-center justify-between px-4 py-3 rounded-lg bg-slate-800 hover:bg-slate-700 border border-slate-700 group">
            <div className="flex items-center gap-3">
              <div className={`p-2 rounded-md ${l.iconBg}`}><l.icon size={18} /></div>
              <div>
                <div className="font-semibold text-white">{l.title}</div>
                <div className="text-xs text-slate-400">{l.desc}</div>
              </div>
            </div>
            <Download size={16} className="text-slate-400 group-hover:text-white" />
          </a>
        ))}
      </div>
    </div>
  );
}
